module.exports = __webpack_public_path__ + "static/media/speed-board.6088f227.svg";